import { Model } from "@tailflow/laravel-orion/lib/model";

export class FieldGroup extends Model<{
    title: string,
}> {
    $resource(): string {
        return "module/fields/admin/field-groups";
    }
}
